import './style.css';

import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

Alpine.plugin(intersect);
Alpine.plugin(collapse);

document.addEventListener('DOMContentLoaded', async () => {
  window.Alpine = Alpine;
  window.Swiper = Swiper;
  window.Navigation = Navigation;
  window.Scrollbar = Scrollbar;
  //for dynamic, per page modules
  let pageModules = document.querySelectorAll("[data-module");
  const moduleNames = new Set();

  pageModules.forEach((moduleElement) => {
    const moduleName = moduleElement.dataset.module;
    if (moduleName) {
      moduleNames.add(moduleName); // Add module name to the set (avoid duplicates)
    }
  });

  //import them for vite
  if (moduleNames.size > 0) {
   const modules = import.meta.glob('./*.js');
   
   const loadModule = async (moduleName) => {
     if (modules[`./${moduleName}.js`]) {
       return await modules[`./${moduleName}.js`]();
     } else {
       console.error(`Module './${moduleName}.js' not found.`);
     }
   };

   //attach the module to alpine
   for (const moduleName of moduleNames) {
     const alpineModule = await loadModule(moduleName);
     Alpine.data(moduleName, alpineModule.default);
   }
  }

  Alpine.start();

  const swiper = new Swiper('.customSwiper', {
    modules: [Navigation, Scrollbar],
    loop: false,
    direction: 'horizontal',
    grabCursor: true,
    speed: 400,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    slidesPerView: "auto",
    navigation: {
      nextEl: '.swiper-nav-next',
      prevEl: '.swiper-nav-prev',
      disabledClass: 'opacity-50'
    },
  });
});